import { HStack, Skeleton, VStack } from '@chakra-ui/react';

export const PriceDetailsSkeleton = () => (
  <VStack align='stretch' gap='2px' textAlign='end'>
    <HStack justify='space-between'>
      <Skeleton height='16px' width='80px' startColor='green.G200' endColor='green.G100' />
      <Skeleton height='16px' width='70px' startColor='green.G200' endColor='green.G100' />
    </HStack>
    <HStack justify='space-between'>
      <Skeleton height='16px' width='60px' startColor='green.G200' endColor='green.G100' />
      <Skeleton height='16px' width='70px' startColor='green.G200' endColor='green.G100' />
    </HStack>
  </VStack>
);

export const TotalRowSkeleton = () => (
  <HStack justifyContent='space-between' alignItems='center' w='100%'>
    <Skeleton height='24px' width='100px' startColor='green.G200' endColor='green.G100' />
    <Skeleton height='20px' width='60px' startColor='green.G200' endColor='green.G100' />
  </HStack>
);
